/**
 * CosNF Wholesale — Custom Theme JavaScript
 * 1. 브랜드명 분리 표시 (제품명에서 [Brand] 추출)
 * 2. 상품 페이지 이미지 슬라이더 (한 장씩 + 좌우 화살표)
 */
(function () {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initBrandNames();
    initProductSlider();
  }

  function initBrandNames() {
    var cardLinks = document.querySelectorAll('.card__heading a');
    cardLinks.forEach(processBrandInCard);

    var productTitle = document.querySelector('.product__title, h1.product__title');
    if (productTitle) processBrandInProductTitle(productTitle);
  }

  function processBrandInCard(linkEl) {
    var title = linkEl.textContent.trim();
    var match = title.match(/^\[([^\]]+)\]\s*/);
    if (!match) return;

    var brandName = match[1];
    var cleanTitle = title.replace(match[0], '');

    linkEl.textContent = cleanTitle;

    var heading = linkEl.closest('.card__heading');
    if (!heading) return;
    var infoBox = heading.parentElement;
    if (!infoBox) return;

    if (infoBox.querySelector('.cosnf-brand')) return;

    var brandEl = document.createElement('p');
    brandEl.className = 'cosnf-brand';
    brandEl.textContent = brandName;
    infoBox.insertBefore(brandEl, heading);
  }

  function processBrandInProductTitle(titleEl) {
    var title = titleEl.textContent.trim();
    var match = title.match(/^\[([^\]]+)\]\s*/);
    if (!match) return;

    var brandName = match[1];

    titleEl.childNodes.forEach(function (node) {
      if (node.nodeType === Node.TEXT_NODE) {
        node.textContent = node.textContent.replace(match[0], '');
      }
    });

    var parent = titleEl.parentElement;
    if (!parent || parent.querySelector('.cosnf-brand')) return;

    var brandEl = document.createElement('p');
    brandEl.className = 'cosnf-brand';
    brandEl.textContent = brandName;
    parent.insertBefore(brandEl, titleEl);
  }

  function initProductSlider() {
    var mediaGallery = document.querySelector('media-gallery');
    if (!mediaGallery) return;

    var mediaItems = Array.from(
      mediaGallery.querySelectorAll('.product__media-item')
    );
    if (mediaItems.length <= 1) return;

    var currentIndex = 0;
    var layout = mediaGallery.getAttribute('data-desktop-layout') || 'stacked';

    if (layout === 'stacked') {
      mediaItems.forEach(function (item, i) {
        if (i > 0) item.setAttribute('data-cosnf-hidden', 'true');
      });
    }

    var viewerEl =
      mediaGallery.querySelector('.product__media-wrapper') ||
      mediaGallery.querySelector('[id^="GalleryViewer"]') ||
      mediaGallery;

    var wrapper = document.createElement('div');
    wrapper.className = 'cosnf-slider-wrapper';
    viewerEl.parentNode.insertBefore(wrapper, viewerEl);
    wrapper.appendChild(viewerEl);

    var prevBtn = makeNavBtn('prev', '\u2039');
    var nextBtn = makeNavBtn('next', '\u203a');
    wrapper.appendChild(prevBtn);
    wrapper.appendChild(nextBtn);

    var dotsEl = document.createElement('div');
    dotsEl.className = 'cosnf-slider-dots';
    wrapper.after(dotsEl);

    var dots = mediaItems.map(function (_, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'cosnf-slider-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', (i + 1) + '번째 이미지');
      dot.addEventListener('click', function () { goTo(i); });
      dotsEl.appendChild(dot);
      return dot;
    });

    function goTo(nextIndex) {
      var idx = ((nextIndex % mediaItems.length) + mediaItems.length) % mediaItems.length;

      if (layout === 'stacked') {
        mediaItems[currentIndex].setAttribute('data-cosnf-hidden', 'true');
        mediaItems[idx].removeAttribute('data-cosnf-hidden');
      } else {
        var targetItem = mediaItems[idx];
        var mediaContainer = targetItem.querySelector('[id^="MediaContainer"]');
        if (mediaContainer && typeof mediaGallery.setActiveMedia === 'function') {
          var mediaId = mediaContainer.id.split('-').pop();
          mediaGallery.setActiveMedia(
            mediaGallery.id.replace('MediaGallery', 'MediaContainer') + '-' + mediaId,
            true
          );
        }
      }

      dots[currentIndex].classList.remove('active');
      dots[idx].classList.add('active');
      currentIndex = idx;
    }

    prevBtn.addEventListener('click', function () { goTo(currentIndex - 1); });
    nextBtn.addEventListener('click', function () { goTo(currentIndex + 1); });

    mediaGallery.addEventListener('slideChanged', function (e) {
      var newIdx = e.detail && e.detail.currentElement
        ? mediaItems.indexOf(e.detail.currentElement)
        : -1;
      if (newIdx >= 0 && newIdx !== currentIndex) {
        dots[currentIndex].classList.remove('active');
        currentIndex = newIdx;
        dots[currentIndex].classList.add('active');
      }
    });
  }

  function makeNavBtn(dir, symbol) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cosnf-slider-nav cosnf-slider-nav--' + dir;
    btn.innerHTML = symbol;
    btn.setAttribute('aria-label', dir === 'prev' ? '이전 이미지' : '다음 이미지');
    return btn;
  }
})();